'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import { styled, css } from 'styled-components';
import { gradients } from '../../abstracts';
import { SimpleBlockContext } from './SimpleBlockContext';
import { SimpleCardContext } from '../SimpleCard/SimpleCardContext';
export const StyledImage = styled.div.withConfig({
  componentId: "aui__sc-6a2a58-0"
})(["position:relative;overflow:hidden;display:flex;border-radius:", ";", ";", ";", " img,picture{width:100%;height:100%;object-fit:", ";}"], ({
  $cardPosition
}) => $cardPosition ? 'var(--aui-border-radius-none)' : 'var(--aui-border-radius-200)', getSize, getMargin, ({
  $variant
}) => $variant === 'product' && css(["background:", ";padding:var(--aui-spacing-200);"], gradients.lightAngle1), ({
  $variant
}) => $variant === 'product' ? `contain` : 'cover');
export const Image = ({
  width,
  height,
  aspectRatio,
  variant,
  ...props
}) => {
  const {
    isInsideBlock
  } = useContext(SimpleBlockContext);
  const {
    imagePosition
  } = useContext(SimpleCardContext);
  return /*#__PURE__*/React.createElement(StyledImage, _extends({
    $width: width,
    $height: height,
    $aspectRatio: aspectRatio,
    $variant: variant,
    $cardPosition: !isInsideBlock ? imagePosition : undefined
  }, props));
};
function getSize({
  $width,
  $height,
  $cardPosition,
  $aspectRatio
}) {
  let snippet = '';
  if ($width || $height) {
    snippet += 'flex-shrink: 0;';
  }
  if ($width !== null && $width !== void 0 && $width.endsWith('%') && $cardPosition) {
    const multiplier = $cardPosition == 'top' || $cardPosition == 'bottom' ? 2 : 1;
    snippet += `width: calc(${$width} + ${multiplier} * var(--aui-spacing-200));`;
  } else if ($width) {
    snippet += `width: ${$width};`;
  }
  if ($height !== null && $height !== void 0 && $height.endsWith('%') && $cardPosition) {
    const multiplier = $cardPosition == 'left' || $cardPosition == 'right' ? 2 : 1;
    snippet += `height: calc(${$height} + ${multiplier} * var(--aui-spacing-200));`;
  } else if ($height) {
    snippet += `height: ${$height};`;
  }
  if ($aspectRatio) {
    snippet += `aspect-ratio: ${$aspectRatio};`;
  }
  return snippet;
}
function getMargin({
  $cardPosition
}) {
  let top, right, bottom, left;
  // eslint-disable-next-line prefer-const
  top = right = bottom = left = 'calc(-1 * var(--aui-spacing-200))';
  if ($cardPosition === 'top') {
    bottom = '0';
  } else if ($cardPosition === 'left') {
    right = '0';
  } else if ($cardPosition === 'right') {
    left = '0';
  } else if ($cardPosition === 'bottom') {
    top = '0';
  } else if (!$cardPosition) {
    top = right = bottom = left = '0';
  }
  return css(["margin:", " ", " ", " ", ";"], top, right, bottom, left);
}